import React, { useMemo, ReactNode } from 'react';
import styled from 'styled-components';

// Helpers
import { card } from '~/App/helpers/mixins';
import { MultiPartFormValues } from '~/App/shared/components/MultiPartForm';
import { IValidation } from '~/App/shared/components/Validation';

type ColumnSegmentStylesProps = {
  isOpen: boolean;
  $isAvailable: boolean;
};

const ColumnSegmentStyles = styled.div<ColumnSegmentStylesProps>`
  ${card}
  margin-top: 1rem;

  opacity: ${(props) => (props.$isAvailable ? '1' : '0.5')};
  display: ${({ isOpen }) => (!isOpen ? 'flex' : 'block')};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  &:first-child {
    margin-top: 0;
  }
`;

type Props = {
  values: MultiPartFormValues;
  part: number;
  children: ReactNode;
  className?: string;
  validation: IValidation;
};

export function ColumnSegment({
  values,
  part,
  children,
  validation,
  className
}: Props) {
  const isOpen = values.partOptions.currentPart === part;
  const isStarted = values.partOptions.partStarted[part];

  const previousIsValid = useMemo(
    () =>
      part === 1 ||
      validation.areValid(values.handlers.getValidationKeys(part - 1)),
    [part, validation, values.handlers]
  );

  const isAvailable = isOpen || (isStarted && previousIsValid);

  return useMemo(
    () => (
      <ColumnSegmentStyles
        className={className}
        isOpen={isOpen}
        $isAvailable={isAvailable}
        id={values.handlers.buildPartName(part)}
        children={children}
      />
    ),
    [children, className, isOpen, part, values.handlers, isAvailable]
  );
}
